module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/americas-890.33b04b9141ea9f00.jpg"+" 890w",
        images: [{path: "https://static.sniffspot.com/packs/img/americas-890.33b04b9141ea9f00.jpg",width: 890,height: 458}],
        src: "https://static.sniffspot.com/packs/img/americas-890.33b04b9141ea9f00.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/americas-890.33b04b9141ea9f00.jpg"},
        
        width: 890,
        height: 458
      }